import { isPlatformBrowser } from "@angular/common";
import { WebsiteService } from "./services/website.service";
import { WebsiteStateService } from "./state-management/services/website-state.service";

export function initializeAppFactory(
  platformId: Object,
  websiteService: WebsiteService,
  websiteStateService: WebsiteStateService,
) {
  return () => {

    if (isPlatformBrowser(platformId)) {
      const redirectRoutePath = '/qrcode';
      if (window.location.pathname.startsWith(redirectRoutePath)) {
        console.log('Redirect-Seite erkannt. Überspringe vollständige App-Initialisierung.');
        return Promise.resolve();
      }
    }

    return Promise.all([
      websiteService.loadWebsiteData(),
      websiteService.loadImageGalleryData(),
      websiteService.loadLogoCarouselData()
    ])
      .then(([websiteData, imageGalleryData, logoCarouselData]) => {
        if (websiteData) {
          websiteStateService.initializeState(websiteData);
          console.log('App erfolgreich initialisiert');
        } else {
          console.warn('Website-Daten konnten nicht geladen werden.');
        }

        if (imageGalleryData) {
          websiteStateService.initializeImageGallery(imageGalleryData);
          // console.log('Image Gallery erfolgreich initialisiert', imageGalleryData);
          console.log('Image Gallery erfolgreich initialisiert');
        } else {
          console.warn('Image Gallery-Daten konnten nicht geladen werden.');
        }

        if (logoCarouselData) {
          websiteStateService.initializeLogoCarousel(logoCarouselData);
          // console.log('Logo Carousel erfolgreich initialisiert', logoCarouselData);
          console.log('Logo Carousel erfolgreich initialisiert');
        } else {
          console.warn('Logo Carousel-Daten konnten nicht geladen werden.');
        }
      })
      .catch(err => {
        console.error('Fehler bei der Initialisierung der App:', err);
      });
  };
}
